export class HttpError extends Error {
    status: any

    constructor(status: any, message: string) {
        super(message)
        this.status = status
    }
}
